import { Button, Flex, Image, Input, Text, VStack } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { ModalAlterarLayout } from './ModalAlterarLayout'
import { useQuery, QueryErrorResetBoundary } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { api } from '../../../services/api'
import { SkeletonLoading } from './SkeletonLoading'
import { ErrorFallback } from './ErrorFallback'
import { useForm } from 'react-hook-form'

async function getLayouts(numeroNota) {
  await new Promise((resolve) => setTimeout(resolve, 1000))
  const response = await api.get(`/arte-produto/listar-layout/${numeroNota}`)

  return response.data.map((item) => ({
    ...item,
    quantidade_negociada: new Intl.NumberFormat('pt-BR').format(item.quantidade_negociada),
  }))
}

export function AlteracaoLayoutManual() {
  const { register, handleSubmit, watch } = useForm()

  const watchAllFields = watch()

  const {
    data: layouts,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: 'layouts',
    queryFn: () => getLayouts(watchAllFields.numeroNota),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10,
    enabled: false,
  })

  function onSearch(data) {
    const { numeroNota } = data

    console.log(numeroNota)

    if (!numeroNota) return

    refetch()
  }

  return (
    <>
      <HeadingPages name="Alteração de Layout Manual" />

      <Layout>
        <VStack spacing={4} align="stretch">
          <Flex onSubmit={handleSubmit(onSearch)} as="form" gap={2} alignItems="center" justifyContent={'center'} maxW="sm" mx="auto">
            <Input placeholder="Número da nota" {...register('numeroNota', { required: 'Campo obrigatório' })} />
            <Button isLoading={isLoading} colorScheme="blue" type="submit">
              Buscar
            </Button>
          </Flex>

          {layouts?.length > 0 && (
            <Text as="h1" textAlign="center" fontSize="xl" fontWeight="bold">
              {layouts?.length} {layouts?.length === 1 ? 'layout' : 'layouts'} encontrado{layouts?.length === 1 ? '' : 's'}
            </Text>
          )}

          <Flex flexDir="column" gap={2}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <QueryErrorResetBoundary>
                {isLoading && <SkeletonLoading />}
                {layouts?.map((item) => (
                  <Flex
                    key={item.id}
                    alignItems="center"
                    justifyContent="space-between"
                    p={2}
                    borderRadius="md"
                    bg="gray.100"
                    border="1px"
                    borderColor="gray.200"
                    shadow="sm"
                  >
                    <Flex alignItems="center" gap={4}>
                      <Image fallbackSrc="https://via.placeholder.com/150" boxSize="100px" src={item.link_imagem} alt={item.nome} />
                      <Flex flexDir="column">
                        <Text>
                          Cód. prod: <strong>{item.codigo_produto}</strong>
                        </Text>
                        <Text>
                          Produto: <strong>{item.nome_produto}</strong>
                        </Text>
                        <Text>
                          Quantidade negociada: <strong>{item.quantidade_negociada}</strong>
                        </Text>
                        <Text>
                          Layout:{' '}
                          <Text
                            as="a"
                            href={item.link_layout}
                            isTruncated
                            color="blue.500"
                            textDecoration="underline"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Clique aqui para visualizar
                          </Text>
                        </Text>
                      </Flex>
                    </Flex>
                    <Flex alignItems="center" gap={4}>
                      <ModalAlterarLayout
                        numeroNota={watchAllFields.numeroNota}
                        codProd={item.codigo_produto}
                        sequencia={item.sequencia}
                        nome={item.nome_produto}
                      />
                    </Flex>
                  </Flex>
                ))}
              </QueryErrorResetBoundary>
            </ErrorBoundary>
          </Flex>
        </VStack>
      </Layout>
    </>
  )
}
